export interface IAboutAction {
  title: string;
  icon: string;
  tool: TOOLS;
  action: (item: IAboutAction) => void;
  key?: string;
  value?: boolean;
  is_svg?: boolean;
  copyValue?: string;
  description?: string;
}

export enum TOOLS {
  TOGGLE = 'TOGGLE',
  BUTTON = 'BUTTON',
  PROFILE = 'PROFILE',
}
